let t = {};
function e() {
  return t;
}
export {
  e as getDefaultOptions
};
//# sourceMappingURL=defaultOptions.js.map
